<template>
    <transition name="fade">
        <div v-show="visible" class="toggle-filter-panel-component load-mask-parent">
            <div :class="loadMask"></div>
            <div class="filters-placeholder">
                <div class="filter-placeholder form-group" v-for="(component) in getComponents">
                    <component
                        :is="loadComponent(component.type)"
                        :config="component.config"
                        :eventBus="$root"
                        :routeParams="routeParams"
                        :queryParams="queryParams"
                        :onChange="onChange"
                        :onDefaultValueSet="onDefaultValueSet"
                    ></component>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import State from "@/Models/State.ts";
import DateFormatter from "@/Models/DateFormatter.ts";
import ValueChecker from "@/services/ValueChecker";

export default {
    components: {},
    props: {
        config: {
            Type: Object,
            default: function () {
                return {
                    components: [],
                    componentIndex: null,
                    visible: true,
                }
            }
        },
        routeParams: {
            Type: Object
        },
        queryParams: {
            Type: Object
        },
        eventBus: {
            Type: Object,
        },
        moduleName: {
            Type: String,
        },
    },
    data() {
        return {
            visible: true,
            events: [],
            state: new State(),
            componentIndex: null,
            components: [],
            interval: null,
            searchInterval: null,
            loadMask: '',
        }
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    inject: ['eventManager'],
    mounted() {
        this.init();
        this.setDefaultValue(this.components);
        this.setState(this.routeParams)
            .setState(this.queryParams);
        this.mountEvents();
    },
    methods: {
        init() {
            this.componentIndex = this.config.index;
            this.components = this.config.components;
            this.visible = this.config.visible;
        },
        onChange(filterName, filterValue) {
            this.setState({[filterName]: filterValue});
            this.$emit('filter-set', filterName, this.state.value);
            this.refresh();
        },
        refresh() {
            clearInterval(this.interval);
            this.interval = setTimeout(() => {
                this.eventManager.emitEvents(this.config.emitEvents['change'] || [], this.state.value);
            }, 2000);
        },
        onDefaultValueSet(filterName, filterValue) {
            this.setState({[filterName]: filterValue});
            this.$emit('filter-set', filterName, this.state.value);
        },
        ready() {
            this.eventManager.emitEvents(this.config.emitEvents['mounted'] || [], this.state.value);
        },
        loadComponent(type) {
            return require(`./filter/${type}.vue`);
        },
        toggle(state) {
            this.visible = !this.visible;
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        defaultBindEvents() {
            return [{
                name: 'toggle',
                componentIndex: this.componentIndex,
            }, {
                name: 'ready',
                componentIndex: this.moduleName,
            }, {
                name: 'setValues',
                componentIndex: this.componentIndex,
            }];
        },
        setDefaultValue(components) {
            components.forEach(c => {
                if (ValueChecker.isEmptyForAllTypes(c.config.value)) {
                    return;
                }

                let config = JSON.parse(JSON.stringify(c.config));

                if ('DateRangeComponent' === c.type) {
                    let dateFormatter = new DateFormatter();
                    config.value = dateFormatter.format(config.value);
                }

                this.setState({[config.name]: config.value});
            });
        },
        setState(data) {
            this.state.value = data;
            this.eventManager.emitEvents(this.config.emitEvents['setState'] || [], this.state.value);

            return this;
        },
        resetState(state) {
            this.state.resetState(state);
            this.$emit('reset-state', this.state.value);
        },
        setValues(eventData, state) {
            this.addLoadMask();
            this.resetState({});
            this.components.forEach((c) => {
                let defaultValue = this.getDefaultValueForComponent(c.type);
                const key = c.config.name;
                const value = state[key] || defaultValue;
                state[key] = value;
                this.$emit(`${key}-set-value`, value);
            });

            this.setState(state);
            this.$emit('filter-set', '', this.state.value);
            this.refresh();
            this.removeLoadMask();
        },
        getDefaultValueForComponent(type) {
            switch (type) {
                case 'DateRangeComponent':
                    return {
                        startDate: null,
                        endDate: null,
                    };
                case 'SelectComponent':
                    return [];
                default:
                    return null;
            }
        },
        unmountEvents() {
            this.eventManager.unbindEvents(this.defaultBindEvents());
        },
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        removeLoadMask() {
            this.loadMask = '';
        },
    },
    computed: {
        getComponents() {
            return this.components.filter(c => c.config.display).sort((a, b) => a.config.position - b.config.position);
        }
    }
}
</script>

<style lang="sass" scoped>

.boolean-filter {
    width: 45px !important;
    margin-top: 0 !important;
    margin-left: -5px !important;

}
.textarea {
    width: 100%;
    min-width: 100%;
    border-color: rgb(222, 222, 222);
    border-radius: 5px;

}
.datepicker-placeholder input {
    min-width: 90%;
    height: 42px;
    border-color: rgb(222, 222, 222);
    border-style: solid !important;
    border-width: 1px;
    border-radius: 5px;

}
.filters-placeholder {
    display:flex;
    flex-wrap:wrap;

}
.filter-placeholder {
    flex-basis: 16.666666667%;
    flex-grow: 16.666666667%;
    flex-shrink: 16.666666667%;

}
.filter-placeholder {
    padding-right: 10px;

}
.input-text-area {
    resize: none !important;
    overflow:auto;
    border-color: rgb(222, 222, 222);
    border-radius: 5px;
    max-height: 43px;

}
.toggle-filter-panel-component {
    position: sticky;
    top: 65px;
    z-index: 49;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.load-mask-parent {
    min-height: auto;
}
</style>



// WEBPACK FOOTER //
// ToggleFilterPanelComponent.vue?6acdbf04